<template>
  <div class="user-account">
    <div class="card-box">
      <div class="card-box_title weight_500">{{ $t('common.email') }}</div>
      <div class="card-box_content">
        {{ email }}
      </div>
    </div>

    <div
      v-if="affiliate_name"
      class="card-box mt-2"
    >
      <div class="card-box_title weight_500">{{ $t('common.affiliate') }}</div>
      <div class="card-box_content">
        {{ affiliate_name }}
      </div>
    </div>

    <div class="card-box mt-8">
      <div class="card-box_title weight_500">{{ $t('links.analyze') }}</div>
      <div class="card-box_content">
        <VerticalCounter
          class="ma-0 hh-counter"
          :hasTitle="false"
        />
      </div>
    </div>

    <div class="card-box mt-8">
      <div class="card-box_title weight_500">
        {{ $t('subscription.discord_tag') }}
      </div>
      <div class="card-box_content">
        <DiscordBox
          :compact="true"
          class="discord-box"
        />
      </div>
    </div>
    <div class="card-box mt-8">
      <div class="card-box_title weight_500">{{ $t('common.install') }}</div>
      <div
        class="card-box_content"
        style="margin: -0.5rem 0 0 0"
      >
        <ExpandCard
          :hasScrollIntoView="false"
          :opened="false"
          style="
            --radius-open: 4px;
            --radius-closed: 4px;
            --title-color: var(--clr-white-0);
            --clr-back-content: transparent;
            --clr-back-title: transparent;
            --clr-back-title-hover: transparent;
            --clr-back-title-active: transparent;
            --title-padding: 0;
            --content-padding: 0 0 1rem 0;
            --icon-opener-margin: 0 1rem 0 0;
            --min-height: 2.5rem;
            --title-direction: row-reverse;
            --title-justify-content: flex-end;
          "
        >
          <template #title>
            {{ $t('user_settings.how_to_install_mobile') }}
          </template>
          <SimpleTabs
            :value="tab"
            :options="[
              { title: $t('common.iphone'), icon: 'mdi-apple', id: 'ios_mobile' },
              { title: $t('common.android'), icon: 'mdi-android', id: 'android' },
            ]"
            class="tabs-stretchs mt-2"
            style="--height: 2.5rem; --inner-flex: 1; --tab-flex: 1"
            @input="v => (tab = v)"
          >
            <template #default="{ item }">
              <div
                class="mdi mr-2"
                :class="item.icon"
              ></div>
              {{ item.title }}
            </template>
          </SimpleTabs>
          <div class="img-container mt-2 f-column">
            <img
              style="max-width: 44rem"
              :src="getImage(`${tab}.webp`)"
            />
          </div>
        </ExpandCard>
        <ExpandCard
          :hasScrollIntoView="false"
          :opened="false"
          style="
            --radius-open: 4px;
            --radius-closed: 4px;
            --title-color: var(--clr-white-0);
            --clr-back-content: transparent;
            --clr-back-title: transparent;
            --clr-back-title-hover: transparent;
            --clr-back-title-active: transparent;
            --title-padding: 0;
            --content-padding: 0;
            --icon-opener-margin: 0 1rem 0 0;
            --min-height: 2.5rem;
            --title-direction: row-reverse;
            --title-justify-content: flex-end;
          "
        >
          <template #title>
            {{ $t('user_settings.how_to_install_desktop') }}
          </template>
          <div class="img-container mt-2 f-column">
            <img
              style="max-width: 800px"
              :src="getImage('pc.webp')"
            />
          </div>
        </ExpandCard>
      </div>
    </div>
  </div>
</template>

<script>
import VerticalCounter from '@/components/VerticalCounter/VerticalCounter'
import DiscordBox from '@/components/Payments/DiscordBox'
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import SimpleTabs from '@/components/AppBar/SimpleTabs'

export default {
  name: 'UserAccount',
  components: {
    VerticalCounter,
    DiscordBox,
    ExpandCard,
    SimpleTabs,
  },
  data() {
    return {
      tab: 'ios_mobile',
    }
  },
  methods: {
    getImage(img) {
      return new URL(`/src/assets/img/howto/${img}`, import.meta.url).href
    },
  },
  computed: {
    user_info() {
      const { user_info } = this.$store.getters
      return user_info
    },
    email() {
      return this.user_info.email
    },
    affiliate_name() {
      return this.user_info.affiliate_name
    },
  },
}
</script>
<style lang="scss" scoped>
@media (max-width: 1023px) {
  .card-box {
    flex-direction: column;
    &_title {
      margin-bottom: 1rem;
    }
  }
}
.user-account {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.card-box {
  display: flex;
  max-width: 960px;
  border-radius: 4px;
  flex-shrink: 0;
  &_title {
    min-width: 10em;
  }
  &_content {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    padding: 0 0 1rem 0;
  }
  &_text {
    position: relative;
    border-radius: 4px;
  }
}

.discord-box {
  max-width: 32rem;
}

.img-container {
  overflow: auto;
  img {
    border-radius: 8px;
    max-width: 90vw;
  }
}
</style>
